import { useContext } from 'react';
import { TenantScopeContext } from '../contexts/TenantScopeContext';
import type { TenantApiClient } from '../lib/tenant-api';

export const useTenantApi = (): TenantApiClient => {
  const tenantApi = useContext(TenantScopeContext);
  if (!tenantApi) {
    throw new Error('useTenantApi must be used within a TenantScopeProvider');
  }
  return tenantApi;
};
